import { vakgebieden } from "../../shared/filterOptions";
import { Answers, DevelopmentType, KnowingType } from "./wizard.types";

const baseUrl =
  process.env.NODE_ENV === "production"
    ? "https://www.maakjestap.nl/stappenplan"
    : "http://localhost:8000/stappenplan";

export const createStappenplanUrl = (data: Answers) => {
  const url = new URL(baseUrl);

  if (data["2"] == KnowingType.DontKnow) {
    url.searchParams.append("t", "dontknow");
    Object.values(vakgebieden).forEach((vakgebied: string) => {
      let amount = 0;
      switch (vakgebied) {
        case "it":
          amount =
            (data.ict1 as number) +
            (data.ict2 as number) +
            (data.ict3 as number);
          break;
        case "zw":
          amount =
            (data.zorg1 as number) +
            (data.zorg2 as number) +
            (data.zorg3 as number);
          break;
        case "cr":
          amount =
            (data.creatief1 as number) +
            (data.creatief2 as number) +
            (data.creatief3 as number);
          break;
        case "on":
          amount =
            (data.onderwijs1 as number) +
            (data.onderwijs2 as number) +
            (data.onderwijs3 as number);
          break;
        case "tc":
          amount =
            (data.techniek1 as number) +
            (data.techniek2 as number) +
            (data.techniek3 as number);
          break;
      }
      url.searchParams.append(vakgebied, amount.toString());
    });
  } else if (data["2"] == KnowingType.Know) {
    url.searchParams.append("t", "know");

    if (data["3.1.2"] === DevelopmentType.Switcher) {
      Array.from(data["3.1.3.1"] as string[]).forEach((vakgebied: string) => {
        url.searchParams.append(vakgebied, "9");
      });
    } else if (data["3.1.2"] === DevelopmentType.Upskiller) {
      url.searchParams.append(data["3.1.3.2"] as string, "9");
    }
  }
  url.searchParams.append(
    "l",
    encodeURIComponent((data["4.2"] as string[]).join(", "))
  );

  url.searchParams.append(
    "d",
    encodeURIComponent((data["4.3"] as string[]).join(", "))
  );
  url.searchParams.append("s", encodeURIComponent((data["4.4"] as string[]).join(", ") as string));

  return url;
};
